"use client";
import { GeistSans } from "geist/font/sans";
import "./globals.css";
import { Analytics } from "@vercel/analytics/react";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import Navbar from "@/components/navbar";
import "dotenv/config";
import { KindeProvider } from "@kinde-oss/kinde-auth-nextjs";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { Toaster } from "react-hot-toast";

export default async function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en" className={GeistSans.className}>
      <head>
        <GoogleAnalytics />
        <meta
          name="google-site-verification"
          content="XnB-Z6B352eIm53VderjnsMPSSBIjzP9I_0dQeHzj-U"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#2563eb" />
      </head>

      <body className="bg-background text-foreground bg-gray-100 flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow container mx-auto py-2 px-4 md:py-8 md:px-4">
          <KindeProvider>
            {children}
            <Toaster position="top-center" />
            <SpeedInsights />
          </KindeProvider>
          <Analytics mode={"production"} />
        </main>
      </body>
    </html>
  );
}
